<template>
  <b-card class="mt-5">
    <b-row>
      <!-- SEARCH FILTER CHART -->
      <b-col class="col-12">
        <SearchFilter
          @handleSubmit="onHandleSubmit"
          :autoSearch="true"
          :dashboardName="dashboardName"
        />
      </b-col>
    </b-row>
    <!-- ROW 1 : BOX CHART (VERTICAL) + PIE CHART -->
    <b-row class="mt-2">
      <!-- BOX CHART -->
      <b-col cols="12" lg="6">
        <b-row>
          <b-col cols="12">
            <div class="card box-main mt-2">
              <div class="card-body box-sub">
                <div class="row">
                  <div
                    class="col text-center"
                    @click="
                      openModal(
                        'จำนวนเรื่องที่ผู้ร้องยื่นเข้ามาเป็น Fasttrack',
                        'SCREENING_VALID_ALL',
                      )
                    "
                  >
                    <h2 class="">{{ total }}</h2>
                    <span class="card-title"
                      >จำนวนเรื่องที่ผู้ร้องยื่นเข้ามาเป็น Fasttrack</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="card box-main mt-2">
              <div class="card-body box-sub">
                <div class="row">
                  <div
                    class="col text-center"
                    @click="
                      openModal(
                        'จำนวนเรื่อง Fasttrack ที่ถูกดำเนินการ Fasttrack',
                        'SCREENING_VALID_VALID',
                      )
                    "
                  >
                    <h2 class="">{{ totalValid }}</h2>
                    <span class="card-title"
                      >จำนวนเรื่อง Fasttrack ที่ถูกดำเนินการ Fasttrack</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="card box-main mt-2">
              <div class="card-body box-sub">
                <div class="row">
                  <div
                    class="col text-center"
                    @click="
                      openModal(
                        'จำนวนเรื่อง Fasttrack ที่ไม่ถูกดำเนินการ Fasttrack',
                        'SCREENING_VALID_INVALID',
                      )
                    "
                  >
                    <h2 class="">{{ totalInvalid }}</h2>
                    <span class="card-title"
                      >จำนวนเรื่อง Fasttrack ที่ไม่ถูกดำเนินการ Fasttrack</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <!-- PIE CHART -->
      <b-col cols="12" lg="6">
        <ApexPieChart
          ref="REF_PIE_FASTTACK_ROLE_SCREENING_SUMMARY_OVERVIEW"
          :filter="filter"
          :issueName="'ScreeningPieChartSummaryOverview'"
          :titleText="'จำนวนเรื่องร้องทุกข์ Fasttrack ที่ส่งออกและคงค้าง'"
        ></ApexPieChart>
      </b-col>
    </b-row>
    <!-- ROW 2 : TABLE + TABLE -->
    <b-row class="mt-2">
      <!-- TABLE LEFT -->
      <b-col cols="12" lg="6">
        <div class="card mt-2">
          <div class="card-body">
            <h3 class="mb-2">{{ tableLeftTitle }}</h3>
            <b-table
              striped
              hover
              small
              responsive
              :items="tableLeftItems"
              :fields="tableFields"
              :tbody-tr-class="rowClass"
              @row-clicked="
                (row) =>
                  onTableRowClicked(
                    row,
                    'SCREENING_SENDING_COMPANY',
                    tableLeftTitle,
                  )
              "
            ></b-table>
          </div>
        </div>
      </b-col>
      <!-- TABLE RIGHT -->
      <b-col cols="12" lg="6">
        <div class="card mt-2">
          <div class="card-body">
            <h3 class="mb-2">{{ tableRightTitle }}</h3>
            <b-table
              striped
              hover
              small
              responsive
              :items="tableRightItems"
              :fields="tableFields"
              :tbody-tr-class="rowClass"
              @row-clicked="
                (row) =>
                  onTableRowClicked(
                    row,
                    'SCREENING_SENDING_DEPARTMENT',
                    tableRightTitle,
                  )
              "
            ></b-table>
          </div>
        </div>
      </b-col>
    </b-row>
    <ModalVue
      @show="openModal"
      ref="REF_REF_FASTTRACK_ROLE_SCREENING_MODAL"
      :filter="filter"
    ></ModalVue>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BLink,
  BCard,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BModal,
  BOverlay,
  BTable,
} from "bootstrap-vue";

// import flatPickr from "vue-flatpickr-component";
import ApexPieChart from "./components/charts/ApexPieChart.vue";
import SearchFilter from "./components/SearchFilter.vue";

import * as userData from "@/auth/localStorageUtils.js";
import * as apiDashboard from "@/store/api/dashboard/index.js";

import ModalVue from "./components/Modal.vue";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BCardText,
    BModal,
    BOverlay,
    BTable,
    ApexPieChart,
    SearchFilter,
    ModalVue,
  },
  props: {},
  data() {
    return {
      total: 0,
      totalValid: 0,
      totalInvalid: 0,
      tableFields: [
        { key: "name", label: "หัวข้อ" },
        { key: "total", label: "จำนวน", class: "text-right" },
      ],
      tableLeftTitle: "จำนวนดำเนินการส่งไปยังผู้ประกอบการโดยคัดกรอง",
      tableLeftItems: [
        { name: "-", total: 0 },
        { name: "-", total: 0 },
        { name: "-", total: 0 },
      ],
      tableRightTitle: "จำนวนดำเนินการส่งต่อหน่วยงานภายในโดยคัดกรอง",
      tableRightItems: [
        { name: "-", total: 0 },
        { name: "-", total: 0 },
        { name: "-", total: 0 },
      ],
      filter: {
        year: new Date().getFullYear().toString(),
        yearEnd: new Date().getFullYear().toString(),
        startDate: "",
        endDate: "",
        userId: null,
        // departmentId: "EF0357A1-C740-4680-91AB-51FA9131FBC1", // คัดกรอง
        departmentId: userData.departmentId(),
      },
      dashboardName:
        "ภาพรวมสถิติการดำเนินการเรื่องร้องทุกข์ Fasttrack ของคัดครอง",
    };
  },
  mounted() {
    // TEST
    // this.ScreeningBoxChartsSummaryValid();
    // this.ScreeningTableChartsSummarySending();
    // this.$refs.REF_PIE_FASTTACK_ROLE_SCREENING_SUMMARY_OVERVIEW.funcScreeningPieChartSummaryOverview();
  },
  methods: {
    onHandleSubmit(submitFilter) {
      console.log("onHandleSubmit .submitFilter", submitFilter);

      this.filter.startDate = submitFilter.startDate;
      this.filter.endDate = submitFilter.endDate;
      console.log("onHandleSubmit .filter", this.filter);

      this.ScreeningBoxChartsSummaryValid(this.filter);
      this.ScreeningTableChartsSummarySending(this.filter);
      this.$refs.REF_PIE_FASTTACK_ROLE_SCREENING_SUMMARY_OVERVIEW.funcScreeningPieChartSummaryOverview(
        this.filter,
      );
    },
    ScreeningBoxChartsSummaryValid() {
      const self = this;
      console.log("ScreeningBoxChartsSummaryValid .filter", self.filter);

      apiDashboard
        .ScreeningBoxChartsSummaryValid(self.filter)
        .then((response) => {
          console.log("ScreeningBoxChartsSummaryValid .response", response);
          console.log(
            "ScreeningBoxChartsSummaryValid .response.data",
            response.data,
          );

          self.total = response.data.data.total ?? 0;
          self.totalValid = response.data.data.valid ?? 0;
          self.totalInvalid = response.data.data.invalid ?? 0;
        })
        .catch((error) => {
          console.log("ScreeningBoxChartsSummaryValid .error", error);
        });
    },
    ScreeningTableChartsSummarySending() {
      const self = this;
      console.log("ScreeningTableChartsSummarySending .filter", self.filter);

      apiDashboard
        .ScreeningTableChartsSummarySending(self.filter)
        .then((response) => {
          console.log("ScreeningTableChartsSummarySending .response", response);
          console.log(
            "ScreeningTableChartsSummarySending .response.data",
            response.data,
          );

          // id = CompanyId / DepartmentId ใช้ส่งเป็น TargetId ตอน drill-down
          // แถว "(ไม่พบ...)" จะได้ id = null -> rowClass/onTableRowClicked กันการคลิกไว้
          self.tableLeftItems = response.data.data.mou.map((item) => ({
            id: item.id,
            name: item.name,
            total: item.total,
          }));
          self.tableRightItems = response.data.data.department.map((item) => ({
            id: item.id,
            name: item.name,
            total: item.total,
          }));

          console.log(
            "ScreeningTableChartsSummarySending .tableLeftItems",
            self.tableLeftItems,
          );
          console.log(
            "ScreeningTableChartsSummarySending .tableRightItems",
            self.tableRightItems,
          );
        })
        .catch((error) => {
          console.log("ScreeningTableChartsSummarySending .error", error);
        });
    },
    openModal(title, keyword) {
      console.log("openModal .title", title);
      console.log("openModal .keyword", keyword);

      const target = this.$refs["REF_REF_FASTTRACK_ROLE_SCREENING_MODAL"];
      target.onSetData(title, keyword, this.filter); // send object to child
      target.$refs["REF_FASTTRACK_ROLE_MODAL"].show();
    },
    // แถวที่ไม่มี id (= "(ไม่พบชื่อบริษัท/หน่วยงาน)") กดไม่ได้ ทำให้ดูจางและไม่ขึ้น pointer
    rowClass(item) {
      if (!item) return null;
      return item.id ? "cursor-pointer" : "text-muted";
    },
    onTableRowClicked(row, keyword, title) {
      if (!row || !row.id) return;

      const target = this.$refs["REF_REF_FASTTRACK_ROLE_SCREENING_MODAL"];
      // แทรก TargetId เข้าไปใน object ที่ Modal.vue จะส่งต่อเป็น params ให้ commonTable
      target.onSetData(`${title} : ${row.name}`, keyword, {
        ...this.filter,
        TargetId: row.id,
      });
      target.$refs["REF_FASTTRACK_ROLE_MODAL"].show();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";

h2,
h5,
.h2,
.h5 {
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 0.5rem;
  color: #32325d;
}

h5,
.h5 {
  font-size: 0.8125rem;
}

.font-weight-bold {
  font-weight: 800 !important;
}

.text-muted {
  color: #8898aa !important;
}

.box-main {
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;
  height: 150px;
  border-top-style: solid;
  border-top-color: #bfb9f1;
  border-top-width: 20px;
  border-radius: 0;

  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.box-main:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  background-color: #f8f9fa;
  /* light gray highlight */
  border-top-color: red;
}

.box-sub {
  // background-color: #f2f1fc;
  background-color: whitesmoke;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.box-sub {
  // background-color: #f2f1fc;
  background-color: whitesmoke;
}

.table-main {
  width: 100%;
  border-top-style: solid;
  border-top-color: #bfb9f1;
  border-top-width: 20px;
  border-radius: 0;

  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.card-underline {
  // border-bottom-style: solid;
  border-bottom-color: black;
}

/* แถวในตารางที่คลิกเข้า drill-down ได้ */
::v-deep tr.cursor-pointer {
  cursor: pointer;
}

</style>
